export enum GCRoleType {
    GeneralContractor = 0,
    Employee = 1,
    Owner = 2,
}
